export default "precision highp float;\nuniform sampler2D map;\nvarying vec2 vUv;\n\nvoid main() {\n    gl_FragColor = texture2D( map, vUv );\n}"